import { render, staticRenderFns } from "./ServiceResultHeader.vue?vue&type=template&id=a84edd38&scoped=true&"
import script from "./ServiceResultHeader.vue?vue&type=script&lang=js&"
export * from "./ServiceResultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84edd38",
  null
  
)

export default component.exports